export const initialAuditLogState = () => ({
  fetchAuditLogLoading: false,
  fetchAuditLogFailure: false,
  fetchAuditLogLoaded: false,
  createAuditLogLoading: false,
  createAuditLogFailure: false,
  createAuditLogLoaded: false
});
